import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  login,
  signup,
  forgotPassword,
  newAccessToken,
  getLinkOfPassword,
  googleLogin,
} from "../service/apiUrl";
import { publicApi } from "../service/Interceptor";
import toast from "../components/Toast/toast";
import {
  setAccessToken,
  setRefreshToken,
  setUserLoginMailId,
} from "../utils/utils";

const initialState = {
  isLoading: false,
  hasError: false,
  user: null,
  // token: null,
};

export const userLogin = createAsyncThunk(
  "auth/user-login",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await publicApi.post(login, payload);
      if (res?.data?.success) {
        const { accessToken, refreshToken } = res.data.data;

        setAccessToken(accessToken);
        setRefreshToken(refreshToken);
        setUserLoginMailId(payload.email);
        // toast.success(res.data.message || "Login successful");
        return true;
      } else {
        const msg =
          res?.data?.message || "Login failed, please try again later";
        console.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error.message ||
        "An unknown error occurred. please try again later.";
      toast.error(msg);
      return rejectWithValue(msg);
    }
  }
);
export const verifyGoogle = createAsyncThunk(
  "auth/verify-google",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await publicApi.post(googleLogin, payload);
      if (res?.data?.success) {
        const { accessToken, refreshToken } = res.data.data;

        setAccessToken(accessToken);
        setRefreshToken(refreshToken);
        setUserLoginMailId(res.data.data.email);
        // toast.success(res.data.message || "Login successful");
        return res?.data?.data;
      } else {
        const msg =
          res?.data?.message || "Google Login failed, please try again later";
        console.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error.message ||
        "An unknown error occurred. please try again later.";
      toast.error(msg);
      return rejectWithValue(msg);
    }
  }
);

export const userSignUp = createAsyncThunk(
  "auth/user-registration",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await publicApi.post(signup, payload);

      if (res?.data?.success) {
        const { accessToken, refreshToken } = res.data.data;
        setAccessToken(accessToken);
        setRefreshToken(refreshToken);
        setUserLoginMailId(payload.email);
        toast.success(res.data.message || "User registered successfully!");
        return true;
      } else {
        const msg =
          res?.data?.message || "Signup failed, please try again later";
        toast.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error.message ||
        "An error occurred during signup.";
      toast.error(msg);
      return rejectWithValue(msg);
    }
  }
);

export const getMailForPasswordReset = createAsyncThunk(
  "auth/getMailforpassword",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await publicApi.post(getLinkOfPassword, payload);
      if (res?.data?.success) {
        return true;
      } else {
        const msg = res?.data?.message || "Sending link to mail failed";
        // toast.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error.message ||
        "An error occurred during signup.";
      // toast.error(msg);
      return rejectWithValue(msg);
    }
  }
);

export const userForgotPassword = createAsyncThunk(
  "auth/forgot-password",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await publicApi.post(forgotPassword, payload);
      if (res?.data?.success) {
        return true;
      } else {
        const msg = res?.data?.message || "Sending link to mail failed";
        // toast.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error.message ||
        "An error occurred during signup.";
      // toast.error(msg);
      return rejectWithValue(msg);
    }
  }
);

export const getAccessToken = createAsyncThunk(
  "auth/getAccessToken",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await publicApi.post(newAccessToken, payload);
      return res.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || error?.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //------------------USER LOGIN------------------
      .addCase(userLogin.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.hasError = true;
        state.isLoading = false;
      })
      //-------------------USER SignUp ---------------
      .addCase(userSignUp.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(userSignUp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.user = action.payload;
        state.user = action.payload;
      })
      .addCase(userSignUp.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      })
      //-------------------User logout -----------------

      //-------------------Forgot Password -------------
      .addCase(userForgotPassword.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(userForgotPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
      })
      .addCase(userForgotPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.hasError = true;
      });
  },
});

export default authSlice.reducer;
